import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    addMessage: (state, action) => {
      state.messages.push({
        role: action.payload.role, // 'user' or 'assistant'
        content: action.payload.content,
        timestamp: action.payload.timestamp || new Date().toISOString(),
      });
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearChat: (state) => {
      state.messages = [];
      state.error = null;
      state.isLoading = false;
    },
  },
});

export const { addMessage, setLoading, setError, clearError, clearChat } = chatSlice.actions;

export default chatSlice.reducer;